import React, { Component } from 'react'
import DayPicker, {DateUtils} from "react-day-picker";
import PropTypes from "prop-types";
import moment from "moment";
import 'react-day-picker/lib/style.css';
import styles from "./DatePicker.module.css"
import { ClickAwayListener } from '@material-ui/core';

import './DayPickerOverride.css';

class DatePicker extends Component {
  constructor(props) {
    super();

    this.state = {
      from: props.from,
      to: props.to,
      enteredTo: props.enteredTo
    }

    this.defaultState = this.state;
    
    this.isSelectingFirstDay = this.isSelectingFirstDay.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }
  handleDayClick(day) {
    const { from, to } = this.props;
    if (this.isSelectingFirstDay(from, to, day)) {
      this.props.setFromDate(day);
    } else {
      this.props.setToDate(day);
    }
  }
  handleDayMouseEnter(day) {
    const { from, to } = this.props;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.props.setEnteredTo(day);
    }
  }

  render() {
    const { from, enteredTo } = this.props;
    const modifiers = { start: from, end: enteredTo };
    const selectedDays = [from, { from, to: enteredTo }];
    const initialMonth = from? moment(from).toDate() : undefined;
    
    if(this.props.isActive) {
      return (
        <ClickAwayListener onClickAway={this.props.close}>
          <DayPicker 
            className={styles.date_picker}
            initialMonth={initialMonth}
            selectedDays={selectedDays}
            modifiers={modifiers}
            onDayClick={this.handleDayClick}
            onDayMouseEnter={this.handleDayMouseEnter}
            />
        </ClickAwayListener>
      )
    }

    return null;
  }
}

DatePicker.defaultProps = {
  from: moment().toDate(),
  to: moment().toDate(),
  enteredTo: null
}

DatePicker.propTypes = {
  from: PropTypes.object,
  to: PropTypes.object,
}

export default DatePicker;